// <div data-controller="copy-protection">
//
// 콘텐츠 무단 복사 방지(작가별 opt-in). 우클릭/드래그선택/복사/이미지드래그를 막고
// 차단 시 안내 토스트를 띄운다. 입력 요소(댓글/스토리 폼)는 예외로 통과시킨다.
import { Controller } from "@hotwired/stimulus";
import { createFlash } from "@/utils/flash";
import { t } from "@/utils/i18n";

const INPUT_SELECTOR = "input, textarea, select, [contenteditable]";
const TOAST_INTERVAL = 1500;

export default class extends Controller {
  connect() {
    this.lastToast = 0;
    this.boundBlock = this.block.bind(this);
    this.element.classList.add("copy-protected");
    this.element.addEventListener("contextmenu", this.boundBlock);
    this.element.addEventListener("copy", this.boundBlock);
    this.element.addEventListener("cut", this.boundBlock);
    this.element.addEventListener("dragstart", this.boundBlock);
  }

  disconnect() {
    this.element.classList.remove("copy-protected");
    this.element.removeEventListener("contextmenu", this.boundBlock);
    this.element.removeEventListener("copy", this.boundBlock);
    this.element.removeEventListener("cut", this.boundBlock);
    this.element.removeEventListener("dragstart", this.boundBlock);
  }

  block(e) {
    // 댓글/스토리 작성 등 입력 요소는 정상 동작하도록 통과
    if (e.target.closest && e.target.closest(INPUT_SELECTOR)) {
      return;
    }
    e.preventDefault();
    // 텍스트 선택은 허용하고, 복사/잘라내기·우클릭·드래그 시도에만 토스트 노출. throttle로 도배 방지.
    this.notify();
  }

  notify() {
    const now = Date.now();
    if (now - this.lastToast < TOAST_INTERVAL) {
      return;
    }
    this.lastToast = now;
    createFlash({ key: "error", message: t("copy_protection.blocked", "콘텐츠 복사가 제한되어 있어요."), ttl: 3, stack: false });
  }
}
